import {Root, Item} from '@radix-ui/react-radio-group'
import React from 'react'
import styled from 'styled-components'

import {Text} from '@/components/text'
import {tokens, colors, radii, focusRingSizes} from '@/theme'

interface Props {
    options: {
        value: string
        label: string
    }[]
    defaultValue: string
    name: string
    onChange?: (value: any) => void
}

export const RadioGroup = ({options, defaultValue, name, onChange}: Props) => (
    <Wrapper
        defaultValue={defaultValue}
        name={name}
        onValueChange={(value) => onChange && onChange(value)}
    >
        {options.map(({value, label}, index) => (
            <Option value={value} key={`${value}${index}`}>
                <Indicator />
                <Text $variant="paragraph-base" $color="muted">
                    {label}
                </Text>
            </Option>
        ))}
    </Wrapper>
)

const Wrapper = styled(Root)`
    display: flex;
    flex-direction: column;
    gap: ${tokens.spacing16};
`

const Indicator = styled.span`
    width: ${tokens.spacing20};
    height: ${tokens.spacing20};
    border: ${tokens.spacing2} solid ${colors.border.dark};
    background-color: ${colors.background.default};
    border-radius: ${radii.circle};
    transition: border-color ${tokens.fastInOut};
`

const Option = styled(Item)`
    border: none;
    background-color: transparent;
    padding: 0;
    display: flex;
    gap: ${tokens.spacing12};
    align-items: center;

    &[data-state='checked'] {
        ${Indicator} {
            border-width: ${tokens.spacing6};
            border-color: ${colors.border.secondary};
        }
    }

    &:focus ${Indicator} {
        outline: transparent solid 2px;
        box-shadow: 0 0 0 ${focusRingSizes['thin']} ${colors.focusRing};
    }
`
